// extracted by mini-css-extract-plugin
module.exports = {"map":"index-module--map--28iWq","covid":"index-module--covid--2f01D","alternativeToMap":"index-module--alternativeToMap--XSxcy","doctor":"index-module--doctor--ltqhj"};